"use client"

import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { useEffect } from "react"
import { ActiveDotSvg } from "./active-dot-svg"
import { FloorPriceChartMoleculeReatom } from "./floor-price-chart-molecule.reatom"

interface Payload {
  value: number
  date: string
}

export interface ActiveDotProps {
  cx?: number
  cy?: number
  payload?: Payload
}

export const ActiveDotReatom = reatomComponent(
  ({ cx, cy, payload }: ActiveDotProps) => {
    const { activeDot } = useMolecule(FloorPriceChartMoleculeReatom)

    useEffect(() => {
      activeDot.set(payload)

      return () => {
        activeDot.set(undefined)
      }
    }, [payload, activeDot])

    return cx && cy ? <ActiveDotSvg x={cx} y={cy} /> : null
  },
)
